module.exports = __webpack_public_path__ + "static/other-skills-5c7c2c71eae4202523c5c13e221b9c58.svg";